import { schemaOf } from "@rezonence/schema-transformer";
import { GenerateImportConfig } from "./GenerateImportConfig";

export const generateImportConfigSchema = schemaOf<GenerateImportConfig>();
